<template>
  <div>
    <div class="addressList" v-for="(address, index) in data" :key="index">
      <b-row>
        <b-col>
          {{ address.address_line1 }}, {{ address.address_line2 }},<br />
          {{ address.city }}, {{ address.postal_code }},
          {{ address.country_code }}
        </b-col>
        <b-col class="text-right">
          <b-button @click="editAddress(index)" size="sm">Edit</b-button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
export default {
  name: "List",
  props: {
    data: {
      type: Array,
      type: [],
    },
  },
  methods: {
    editAddress(index) {
      this.$emit("editAddress", index);
    },
  },
};
</script>

<style>
.addressList {
  width: 100%;
  padding: 10px 20px;
  background-color: #f4f4f4;
  border-left: 4px solid #52bc00;
  margin-bottom: 6px;
}
</style>
